import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Image } from 'react-native'
import { useStores } from '@trivie/core'
import { color } from '@trivie/ui-web/theme/color'
import { Text } from '@trivie/ui-mobile'
import { Text as WebText } from '@trivie/ui-web/components/text'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import Badge from '@mui/material/Badge'
import { ProfileDropdown } from './profile-dropdown'
import { Route } from './routes'
import { MessagesApi } from '@trivie/core/src/services/api-objects'
const _snakeCase = require('lodash/snakeCase')
const logo = require('../assets/logo.png')

const useStyles = makeStyles(() =>
  createStyles({
    navItem: {
      '&:hover': {
        backgroundColor: color.palette.paperBorder,
        borderRadius: 10,
      },
      height: 50,
      width: 210,
      paddingRight: 20,
      cursor: 'pointer',
    },
  }),
)

export const Sidebar = observer((props: any) => {
  const location = useLocation()
  const history = useHistory()
  const classes = useStyles()
  const { userStore, uiStore } = useStores()
  const { user, enterpriseTier, notifications, getNotifications, checkNotifications } = userStore
  const { displayRoutes } = props

  const [openedDrawer, setOpenedDrawer] = useState<any>(undefined)
  const [notificationData, setNotificationData] = useState(0)

  const [active, setActive] = useState<any>(undefined)

  useEffect(() => {
    displayRoutes.forEach((route: any) => {
      if (location.pathname.includes(route.path)) {
        setActive(route.path)
      }
    })
  }, [location.pathname, displayRoutes, enterpriseTier])

  useEffect(() => {
    displayRoutes.forEach((route: Route) => {
      if (location.pathname.includes(route.path)) {
        setOpenedDrawer(route.path)
      }
    })

    const pr = ['/library', '/play', '/notifications', '/profile']
    const permittedRoutes =
      user?.workspace_settings?.feed_enabled ||
      userStore.user?.workspace_settings?.feed_enabled === undefined
        ? ['talk', ...pr]
        : ['dashboard', ...pr]

    const route = location.pathname

    if (permittedRoutes.includes(route)) {
      if (user) {
        getNotifications(user.id)
      }

      const newNotificationsTotal = notifications?.new?.length + notifications?.priority?.length
      setNotificationData(newNotificationsTotal)
    }

    return () => {
      if (route === '/notifications') {
        if (user) {
          MessagesApi.markAllAsRead(user?.id)
        }
      }
    }
  }, [location])

  const onNavItemClick = (path: string) => {
    setActive(path)
    history.push(path)
    if (user?.id) {
      checkNotifications(user?.id)
    }
  }
  const renderCompanyLogo = () => {
    return <Image source={logo} style={COMPANY_LOGO} />
  }
  return (
    <nav
      style={{
        height: '100%',
        zIndex: 997,
        width: 230,
        minWidth: 230,
        backgroundColor: '#FFFFFF',
      }}
    >
      <div className="off-screen">
        <a href="#contentSearch" className="skip-link">
          Skip to Primary Navigation
        </a>
      </div>
      <ul
        style={{
          listStyleType: 'none',
          position: 'absolute',
          padding: 0,
          margin: 0,
          height: '100%',
          minWidth: 230,
          borderRight: '1px solid #EFF0F6',
        }}
      >
        {renderCompanyLogo()}
        {displayRoutes?.map((topLevelRoute: any, index: number) => {
          const isOpen = active === topLevelRoute.path
          if (
            userStore.user?.workspace_settings?.feed_enabled !== undefined &&
            !userStore.user?.workspace_settings?.feed_enabled
          ) {
            if (
              topLevelRoute.name === 'talk' ||
              topLevelRoute.name === 'settings' ||
              topLevelRoute.name === 'profile'
            ) {
              return
            }
          } else {
            if (topLevelRoute.name === 'dashboard' || topLevelRoute.name === 'profile-alt') {
              return
            }
          }
          return (
            topLevelRoute && (
              <ul
                key={`ROUTE_LIST_${index}`}
                style={{
                  listStyleType: 'none',
                  paddingLeft: 0,
                  margin: 0,
                  marginBottom: 8,
                }}
              >
                <li className={classes.navItem} key={`ROUTE_${index}`}>
                  <div
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        onNavItemClick(topLevelRoute.path)
                      }
                    }}
                    data-qat={`sidenav_${_snakeCase(topLevelRoute.name)}`}
                    onClick={() => onNavItemClick(topLevelRoute.path)}
                    style={{
                      ...(isOpen ? ACTIVE_LINK_TOP : LINK),
                      color: isOpen ? color.palette.blueLink : color.shade70,
                    }}
                    role="link"
                    tabIndex={0}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div
                        style={{
                          ...LEFT_BORDER,
                          backgroundColor: isOpen ? 'transparent' : 'initial',
                        }}
                      />
                      {topLevelRoute.label === 'Notifications.header' && notificationData >= 1 ? (
                        <Badge
                          badgeContent={notificationData}
                          sx={{
                            '.MuiBadge-badge': {
                              backgroundColor: color.red,
                              right: 12,
                              top: 2,
                              color: color.white,
                            },
                          }}
                        >
                          {topLevelRoute.icon(isOpen, true)}
                        </Badge>
                      ) : (
                        <>{topLevelRoute.icon(isOpen, true)}</>
                      )}
                      <Text
                        variant="body1Medium"
                        tx={topLevelRoute.label}
                        style={{
                          fontWeight: isOpen ? '600' : '500',
                          minWidth: 77,
                          marginLeft: 8,
                          color: isOpen ? color.palette.blueLink : color.shade70,
                        }}
                      />
                    </div>
                  </div>
                </li>
              </ul>
            )
          )
        })}

        <div style={{ position: 'absolute', bottom: 50, marginLeft: 15 }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-evenly',
              alignItems: 'flex-start',
            }}
          >
            <hr
              style={{
                marginLeft: 6,
                color: 'white',
                marginBottom: 22,
                width: 178,
                height: 1,
                backgroundColor: '#E5E5E5',
                border: 'none',
              }}
            />

            <div style={{ marginLeft: 7 }}>
              <ProfileDropdown />
            </div>
            {user?.first_name && user?.last_name && (
              <WebText
                style={{
                  fontFamily: uiStore.branding.font_family,
                  fontWeight: '600',
                  fontSize: 14,
                  paddingTop: 12,
                  paddingBottom: 1,
                  marginLeft: 7,
                }}
                text={`${user?.first_name} ${user?.last_name}`}
                variant="body1Emphasized"
              />
            )}
            <WebText
              text={user?.email}
              variant="body1Medium"
              style={{
                color: color.shade50,
                fontFamily: uiStore.branding.font_family,
                fontWeight: '400',
                paddingTop: user?.first_name && user?.last_name ? 0 : 12,
                fontSize: 12,
                marginLeft: 7,
              }}
            />
          </div>
        </div>
      </ul>
    </nav>
  )
})

const COMPANY_LOGO: any = {
  maxWidth: 160,
  height: 36,
  margin: 20,
  objectFit: 'contain',
}
const LINK: React.CSSProperties = {
  height: 50,
  textDecoration: 'none',
  alignSelf: 'center',
  display: 'flex',
  color: 'rgba(0,0,0,0.7)',
  width: '100%',
  alignItems: 'center',
  fontWeight: 500,
  letterSpacing: '-0.154',
  marginBottom: 8,
}
const ACTIVE_LINK_TOP: React.CSSProperties = {
  textDecoration: 'none',
  alignSelf: 'center',
  alignItems: 'center',
  display: 'flex',
  width: '100%',
  color: color.blue,
  fontSize: 14,
  fontWeight: 600,
  height: '100%',
}
const LEFT_BORDER: React.CSSProperties = {
  backgroundColor: color.palette.blueLink,
  width: 4,
  height: 32,
  borderTopRightRadius: 100,
  borderBottomRightRadius: 100,
  marginRight: 16,
}
